import { createTheme } from '@mui/material/styles';

export const defiTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#7B61FF',
      light: '#9D89FF',
      dark: '#5A3FFF',
    },
    secondary: {
      main: '#21CBF3',
      light: '#62DAFF',
      dark: '#0098CC',
    },
    background: {
      default: '#0A061D',
      paper: '#13102B',
    },
    text: {
      primary: '#FFFFFF',
      secondary: '#B4B7C5',
    },
  },
  shape: {
    borderRadius: 12,
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          background: 'linear-gradient(90deg, #13102B 0%, #1A1632 100%)',
          backdropFilter: 'blur(10px)',
          boxShadow: '0 4px 30px rgba(0, 0, 0, 0.1)',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: 'none',
          fontSize: '1rem',
          padding: '10px 24px',
        },
        contained: {
          background: 'linear-gradient(45deg, #7B61FF 0%, #21CBF3 100%)',
          boxShadow: '0 4px 20px rgba(123, 97, 255, 0.25)',
          '&:hover': {
            background: 'linear-gradient(45deg, #9D89FF 0%, #62DAFF 100%)',
            boxShadow: '0 6px 25px rgba(123, 97, 255, 0.35)',
          },
        },
        outlined: {
          borderColor: '#7B61FF',
          color: '#7B61FF',
          '&:hover': {
            borderColor: '#9D89FF',
            color: '#9D89FF',
            background: 'rgba(123, 97, 255, 0.08)',
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          background: 'linear-gradient(135deg, rgba(19, 16, 43, 0.95) 0%, rgba(26, 22, 50, 0.95) 100%)',
          backdropFilter: 'blur(10px)',
          borderRadius: 16,
          border: '1px solid rgba(123, 97, 255, 0.1)',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          background: 'linear-gradient(135deg, rgba(19, 16, 43, 0.95) 0%, rgba(26, 22, 50, 0.95) 100%)',
          backdropFilter: 'blur(10px)',
          borderRadius: 16,
          border: '1px solid rgba(123, 97, 255, 0.1)',
        },
      },
    },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontSize: '2.5rem',
      fontWeight: 600,
      background: 'linear-gradient(45deg, #FFFFFF 30%, #B4B7C5 90%)',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
    },
    h2: {
      fontSize: '2rem',
      fontWeight: 600,
      color: '#FFFFFF',
    },
    h6: {
      fontSize: '1.25rem',
      fontWeight: 500,
      color: '#FFFFFF',
    },
  },
});